import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
@Injectable()
export class IngresoService {
  public dataBorradores: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  constructor() {}
}



// WEBPACK FOOTER //
// D:/F210-INGRESO/cambio_enlace_ayuda/rec_ng_ingresorenta210/src/app/components/services/ingreso.service.ts